import { Divider, MoiaButton, MoiaCard } from '@backoffice-frontend/patterns'
import { useTranslation } from 'react-i18next'

export const AllAlertsAreSolvedActionCard = ({
  closeModal,
  pendingUpdate,
}: {
  closeModal: () => void
  pendingUpdate: boolean
}) => {
  const { t } = useTranslation()
  return (
    <MoiaCard
      highlight="disabled"
      strongHighlight
      compact
      css={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0px 4px 6px -1px rgba(0, 12, 21, 0.12), 0px 0px 4px -1px rgba(0, 12, 21, 0.08)`,
      }}
    >
      <div
        css={{
          display: 'grid',
          gridTemplateRows: '1fr auto auto',
          height: '100%',
        }}
      >
        <div
          css={theme => ({
            display: 'grid',
            alignItems: 'center',
            justifyItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            backgroundColor: theme.semantic.ColorSurfaceReducedAlternative,
            margin: theme.space.Space6,
          })}
        ></div>
        <Divider css={{ gridRow: '2' }} />
        <div
          css={theme => ({
            display: 'flex',
            justifyContent: 'flex-end',
            margin: theme.space.Space6,
          })}
        >
          <MoiaButton
            submitting={pendingUpdate}
            color="primary"
            onClick={closeModal}
          >
            {t('adFleetMap_closeVehicleStream_button')}
          </MoiaButton>
        </div>
      </div>
    </MoiaCard>
  )
}
